<div>
  <h4>System Settings Maintenance</h4>
  <br/>
  <hr/>
  @if (isLoading) {
    <span style="margin-left:8px">
      <i class="pi pi-spin pi-spinner" style="font-size: 3.5em"></i>
    </span>
  }
  @for (setting of settings; track setting) {
    <div style="margin-bottom: 10px;">
      @if (!setting.claimName || claims.includes(setting.claimName)) {
        <app-setting-row [setting]="setting"></app-setting-row>
      }
    </div>
  }
</div>